import { useFetch } from "../../../hooks/api";
import { useAppSelector } from "../../../redux/hooks";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPOrderConversionTrackingProducts = (campaignId) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useFetch(
    ["dspConversionTrackingProducts", dspAdvertiser?.id],
    "/dsp/conversion_tracking_products",
    { campaignId, marketplace: marketPlace, dsp_seller_info_id: dspAdvertiser?.id },
    {
      select: (res) => {
        return res.data?.productTrackingList ?? [];
      },
      enabled: !!dspAdvertiser?.id,
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
